<template>
    <div class="AmbassadorshipContentList w-lg">
        <h2 class="font-bold">
            Indhold
        </h2>
        <a
            v-for="content of contents"
            :key="content.id"
            class="AmbassadorshipContentList__card mb-4 block list-group-item rounded-lg bg-white border rounded-lg"
            :href="content.media_url"
            target="_blank"
        >
            <div class="flex p-1 text-black flex-col md:flex-row">
                <div class="flex-1">
                    <ContentMedia
                        class="AmbassadorshipContentList__image bg-center h-full"
                        v-bind="{ content }"
                    />
                </div>
                <div
                    class="AmbassadorshipContentList__content flex items-center justify-between flex-row"
                >
                    <div class="p-t-lg sm:p-6 w-full md:w-5/6">
                        <p class=" mb-0">{{ types(content) }}</p>
                        <p class="text-gray-600 font-thin m-b-md text-sm">
                            {{ getExcerpt(content) }}
                        </p>
                        <p class="text-gray-600 font-thin m-b-md text-sm">
                            {{ content.media_published_at | past | relative }}
                        </p>
                        <ContentInsights
                            :columns="{ default: 2, xs: 2, sm: 2, md: 2, xl: 2 }"
                            :rows="4"
                            :gap="{ default: '10px', sm: '15px' }"
                            :model="content"
                        >
                            <template v-slot:default="{ metric }">
                                <span class="text-2xl font-thin m-b-xs"
                                    >{{ Number(metric.value).toLocaleString() }}
                                </span>
                                <h5 class="text-gray-600 font-thin m-b-xs">{{ metric.name }}</h5>
                            </template>
                        </ContentInsights>
                    </div>
                    <div class="p-md sm:p-lg">
                        <i class="fa fa-external-link"></i>
                    </div>
                </div>
            </div>
        </a>
    </div>
</template>

<style lang="less" type="text/less">
@import '~dashboard-less/variables';
@import '~dashboard-less/spark/utilities';

.AmbassadorshipContentList__card {
    border-radius: 15px !important;
}
.AmbassadorshipContentList__image {
    @media (max-width: @screen-xs-max) {
        padding-top: 60%;
    }
    @media (min-width: @screen-sm-min) {
        padding-top: 120%;
    }
}
.AmbassadorshipContentList__content {
    flex: 2 1 18%;
}
</style>

<script type="text/babel">
import ContentInsights from 'dashboard-js/components/contents/ContentInsights'
import ContentMedia from 'dashboard-js/components/influencers/ContentMedia'

export default {
    components: { ContentMedia, ContentInsights },

    props: {
        contents: {},
    },

    methods: {
        getExcerpt(content) {
            return content.media_description.substr(0, 100) + '...'
        },

        types(content) {
            return content.is_story ? 'Instagram Story' : 'Instagram Post'
        },
    },
}
</script>
